import accountUsageReducer from './accountUsageSlice';
import appVersionReducer from './appVersionSlice';
import authReducer from './authSlice';
import balanceReducer from './balanceSlice';
import blotterReducer from './blotterSlice';
import celerMarketReducer from './celerMarketSlice';
import chartDataReducer from './chartDataSlice';
import languageReducer from './languageSlice';
import liteMarketReducer from './liteMarketSlice';
import marketPairReducer from './marketPairSlice';
import mosaicReducer from './mosaicSlice';
import nopPositionReducer from './nopPositionSlice';
import notificationsReducer from './notificationSlice';
import ohoReducer from './ohoSlice';
import openPositionReducer from './openPositionSlice';
import portalPlatformReducer from './portalPlatformSlice';
import settingReducer from './settingSlice';
import tableSettingReducer from './tableSettingSlice';
import tickerReducer from './tickerSlice';
import traderMarketReducer from './traderMarketSlice';
import workspaceReducer from './workspaceSlice';
import xplorSpotLayoutReducer from './xplorSpotLayoutSlice';
import xplorTraderLayoutReducer from './xplorTraderLayoutSlice';

import { combineReducers } from 'redux';

export default combineReducers({
    appVersion: appVersionReducer,
    accountUsage: accountUsageReducer,
    auth: authReducer,
    balance: balanceReducer,
    blotter: blotterReducer,
    celerMarket: celerMarketReducer,
    chartData: chartDataReducer,
    language: languageReducer,
    liteMarket: liteMarketReducer,
    marketPair: marketPairReducer,
    mosaic: mosaicReducer,
    nopPosition: nopPositionReducer,
    notifications: notificationsReducer,
    oho: ohoReducer,
    openPosition: openPositionReducer,
    portalPlatform: portalPlatformReducer,
    settings: settingReducer,
    tableSetting: tableSettingReducer,
    ticker: tickerReducer,
    traderMarket: traderMarketReducer,
    workspace: workspaceReducer,
    xplorSpotLayout: xplorSpotLayoutReducer,
    xplorTraderLayout: xplorTraderLayoutReducer
});
